/**
 * Whether a chat can be trusted as unchanged since it was last confirmed
 * complete, from Graph's own bookkeeping alone — no network call needed.
 *
 * Chat messages have no delta endpoint (§8), so this comparison is what lets
 * a repeat export notice new activity in an otherwise-finished chat, without
 * assuming anything about the messages endpoint's ordering.
 *
 * Deliberately conservative: either timestamp missing means "cannot be sure,"
 * which resolves to false (re-scan) rather than true (skip) — a needless
 * re-scan costs a few requests; a wrongly-skipped chat costs silently missing
 * a message forever, since there is nothing else that would catch it later.
 *
 * Kept in its own file, free of any import back to the Graph/auth stack, so
 * it can be unit tested directly under Node — export.ts's own import chain
 * reaches auth/config.ts, which reads `import.meta.env` at module load time
 * and only exists under Vite.
 */
export function chatUnchangedSinceCompletion(
    chatLastUpdatedDateTime: string | undefined,
    completedAtSourceUpdate: string | undefined
): boolean {
    return (
        chatLastUpdatedDateTime !== undefined &&
        completedAtSourceUpdate !== undefined &&
        chatLastUpdatedDateTime <= completedAtSourceUpdate
    );
}
